import React from 'react';
import { Col, Container, Row, Button, Accordion, Card } from 'react-bootstrap'
import Gefaesgroesen from './Gefaesgroesen'



export default function Pflanzgefaese(){
    
    return(
        <Col xs={12}>
            <h1 className="py-2">Pflanzgefäße</h1>
            <Row className="py-2">
                <Col xs={12} lg={4}>
                Neben dem Gartenbau vertreiben wir auch Pflanzgefäße aus Cortenstahl. Wir erstellen ihnen gerne ein Angebot.
                Abholung bei uns oder Lieferung und Bepflanzung in und um München möglich!
                </Col>

            </Row>
            <Row>
                <Col xs={12} md={4} className="pb-2 pb-md-0">
                    <img className="img-fluid" src={require('../media/gefaese/adezz_1.jpg')} />
                </Col>
                <Col xs={12} md={4} className="pb-2 pb-md-0">
                    <img className="img-fluid" src={require('../media/gefaese/adezz_2.jpg')} />
                </Col>
                <Col xs={12} md={4}>
                    <img className="img-fluid" src={require('../media/gefaese/adezz_3.jpg')} />
                </Col>
            </Row>
            <Row>
                <Col>
                <Accordion fluid>
                    <Card fluid>
                        <Card.Header>
                            <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                Verfügbare Größen   &#xbb;
                            </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse fluid eventKey="0">
                            <Card.Body>
                                <Container fluid>
                                    <Row>
                                        <Gefaesgroesen />
                                    </Row>
                                </Container>
                                
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
                </Col>
   
            </Row>

        </Col>
    )
}   